module.exports = __webpack_public_path__ + "img/bot_yf1.f60abc6e.png";